import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";


const keyList = {
    smsUpdate : 'GALLERY_UPDATE',
    smsDelete : 'GALLERY_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        
        av:[],
        av_detail:{},
       
        submitLoading: false,
        submitError: false,
        submitSuccess: false,

        avLoading: false,
        avError: false,

        
       
        ...store
    },

    mutations : {
        ...mutations,

        SET_AV(state, av) {
            state.av = av;
        },
        SET_AV_DETAIL(state, detail) {
            state.job_detail = detail;
        },

        SUBMIT_LOADING (state, loading) {
            state.submitLoading = loading;
        },
        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        },

        SUBMIT_ERROR (state, hasError) {
            state.submitError = hasError;
        },


        AV_LOADING (state, loading) {
            state.avLoading = loading;
        },

        AV_ERROR (state, hasError) {
            state.avError = hasError;
        },
        


       
    },

    actions: {
        //Audio Visuals
        async addAV ({commit, dispatch}, payload) {
            commit('AV_LOADING', true);
            commit('AV_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try{
                let response = await axios.post(V1API.av_create, payload.av, config).then(result=>{
                    let data = result.data
                    return data

                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchAVList')
               
               
                return response

            }catch (e) {
                commit('AV_ERROR', true);
            }finally {
                commit('AV_LOADING', false);
            }
        },

        async fetchAVDetail ({ commit },payload) {
            commit('AV_LOADING', true);
            commit('AV_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let result = await axios.get(V1API.av_details + payload, config);
                let response = result.data.data

                commit('SET_AV_DETAIL', response);
                
                

            } catch(error) {
                commit('AV_ERROR', true);
            }
            finally {
                commit('AV_LOADING', false);
            }
        },

       


        async fetchAVList ({ commit }) {
            commit('AV_LOADING', true);
            commit('AV_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let result = await axios.get(V1API.av_list, config);
                let response = result.data

                commit('SET_AV', response.data);

            } catch(error) {
                commit('AV_ERROR', true);
            }
            finally {
                commit('AV_LOADING', false);
            }
        },


    
        async updateAV ({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {

                let response = await axios.patch(V1API.av_edit+payload.av_id, payload.av, config).then(result=>{
                    let data = result.data
                    return data

                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchAVList')
              
                return response

            }catch (e) {
                commit('AV_ERROR', true);
            }finally {
                commit('AV_LOADING', false);
            }
        },

        
        async deleteAV({commit, dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };
          
            let response = await axios.delete(V1API.av_delete+payload.delete, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchAVList')
            
            return response
        },


    

    },

    getters: {}
}
